var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay',{attrs:{"show":_vm.loading}},[_c('page-header',{attrs:{"screen-name":"Editar Usuário","link-items":_vm.linkItems}}),(!_vm.loading)?_c('Form',{attrs:{"mode":"update"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }